'use client';

import { observer } from 'mobx-react-lite';
import { useContext, useEffect, type ReactElement, type ReactNode } from 'react';
import { StoreContext } from './store.provider';
import { isTMA, retrieveLaunchParams, retrieveRawInitData } from '@telegram-apps/sdk';
import { useAuth } from '@/lib/services/tma/tma.service';
import { useRouter } from 'next/navigation';
import { LoadingSpinner } from '../ui/loading-spinner';

export default observer(function TmaProvider({
  children,
}: Readonly<{ readonly children: ReactNode }>): ReactElement {
  const { userStore } = useContext(StoreContext);
  const { auth } = useAuth();
  const router = useRouter();

  useEffect(() => {
    (async () => {
      try {
        if (isTMA()) {
          if (!userStore.isAuth) {
            const authorization = retrieveRawInitData();
            if (authorization) {
              await auth.mutateAsync(authorization);
              const startParam = retrieveLaunchParams().tgWebAppStartParam;
              if (startParam) {
                const href = Buffer.from(startParam, 'base64').toString('utf-8');
                if (href.startsWith('/')) router.push(href);
              }
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, [userStore.isAuth]);

  return auth.isPending ? (
    <div className="absolute top-0 w-full h-screen flex items-center justify-center gap-2.5">
      <LoadingSpinner className="w-6 h-6" />
      <h1 className="text-base font-semibold leading-snug">Authorization</h1>
    </div>
  ) : (
    <>{children}</>
  );
});
